// utils/simpleMomentFormatter.js
import moment from 'moment';

// ইংরেজি লোকেল সেট করুন (ডিফল্ট)
moment.locale('en');

// শুধুমাত্র ডেট
export const formatDate = date => {
  if (!date) return '';
  const d = moment(date);
  return d.isValid() ? d.format('DD/MM/YYYY') : 'Invalid Date';
};

// ডেট + সময়
export const formatDateTime = date => {
  if (!date) return '';
  const d = moment(date);
  return d.isValid() ? d.format('DD/MM/YYYY hh:mm A') : 'Invalid Date';
};

// শুধুমাত্র সময়
export const formatTime = date => {
  if (!date) return '';
  const d = moment(date);
  return d.isValid() ? d.format('hh:mm A') : 'Invalid Time';
};

// রিলেটিভ টাইম (2 days ago, 3 hours ago)
export const timeAgo = date => {
  if (!date) return '';
  const d = moment(date);
  return d.isValid() ? d.fromNow() : 'Invalid Date';
};

// ক্যালেন্ডার ফরমেট (Today, Yesterday, etc.)
export const calendarFormat = date => {
  if (!date) return '';
  const d = moment(date);
  return d.isValid() ? d.calendar() : 'Invalid Date';
};

// ফুল ডেট ফরমেট (Wednesday, July 29, 2026)
export const formatFullDate = date => {
  if (!date) return '';
  const d = moment(date);
  return d.isValid() ? d.format('dddd, MMMM DD, YYYY') : 'Invalid Date';
};

// শর্ট ডেট (29 Jul 2026)
export const formatShortDate = date => {
  if (!date) return '';
  const d = moment(date);
  return d.isValid() ? d.format('DD MMM YYYY') : 'Invalid Date';
};

// ISO ফরমেট (2026-07-29T10:30:00)
export const formatISO = date => {
  if (!date) return '';
  const d = moment(date);
  return d.isValid() ? d.format('YYYY-MM-DDTHH:mm:ss') : 'Invalid Date';
};

// ডেট ডিফারেন্স (কত দিন আগে)
export const getDaysAgo = date => {
  if (!date) return '';
  const d = moment(date);
  if (!d.isValid()) return 'Invalid Date';

  const days = moment().diff(d, 'days');

  if (days === 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days} days ago`;
  if (days < 30) return `${Math.floor(days / 7)} weeks ago`;
  if (days < 365) return `${Math.floor(days / 30)} months ago`;
  return `${Math.floor(days / 365)} years ago`;
};

// কাস্টম ফরমেট
export const formatCustom = (date, formatString) => {
  if (!date) return '';
  const d = moment(date);
  return d.isValid() ? d.format(formatString) : 'Invalid Date';
};

// US ফরমেট (MM/DD/YYYY)
export const formatUSDate = date => {
  if (!date) return '';
  const d = moment(date);
  return d.isValid() ? d.format('MM/DD/YYYY') : 'Invalid Date';
};

// ইউকে ফরমেট (DD/MM/YYYY) - ইতিমধ্যে formatDate আছে
// Time in 24-hour format (14:30)
export const formatTime24 = date => {
  if (!date) return '';
  const d = moment(date);
  return d.isValid() ? d.format('HH:mm') : 'Invalid Time';
};

// Date with timezone
export const formatWithTimezone = date => {
  if (!date) return '';
  const d = moment(date);
  return d.isValid() ? d.format('DD/MM/YYYY hh:mm A Z') : 'Invalid Date';
};
